<template>
  <div class="modal-content">
    <div class="content-container">
      <h3 class="title-error" v-if="!preview.length">
        Настройте интеграцию с Байторгом в своем портале Битрикс24
      </h3>
      <BitrixExportPurchaseItem
        v-for="purchase in preview"
        :purchase="purchase"
        :key="purchase.proposalId"
        :override-purchase-name="overridePurchaseName"
        :title-overrides="titleOverrides"
        ref="purchaseItems"
      />
    </div>
    <div class="modal-footer">
      <div class="btns-container">
        <button
          class="toggle-btn"
          :class="{ active: isDeal }"
          type="button"
          @click="() => toggleEntity('isDeal')"
        >
          <span></span>
          <span>Сделка</span>
        </button>
        <button
          class="toggle-btn"
          :class="{ active: isLead }"
          type="button"
          @click="() => toggleEntity('isLead')"
        >
          <span></span>
          <span>Лид</span>
        </button>
      </div>

      <div class="btns-container">
        <button class="btn btn-cancel" @click="backHandler">Назад</button>
        <button
          class="btn btn-export"
          @click="exportHandler"
          :disabled="!isDeal && !isLead"
        >
          Отправить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import BitrixExportPurchaseItem from "./BitrixExportPurchaseItem.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "BitrixExportModal",
  components: { BitrixExportPurchaseItem },
  data() {
    return {
      titleOverrides: {},
      isLead: false,
      isDeal: false,
    };
  },
  computed: {
    ...mapGetters("bitrix", ["preview", "lastSelectedEntityTypes"]),
  },
  methods: {
    ...mapActions("bitrix", ["resetBitrixExportState", "sendToBitrix"]),
    overridePurchaseName(proposalNumber, newName) {
      this.titleOverrides[proposalNumber] = newName;
    },
    toggleEntity(type) {
      this[type] = !this[type];
    },
    backHandler() {
      this.$modal.close();
    },
    async exportHandler() {
      if (this.$refs.purchaseItems) {
        this.$refs.purchaseItems.forEach((item) => {
          if (item.isEditName) {
            item.endEditName();
          }
        });
      }

      const lotIds = this.preview
        .map((p) => p.lots)
        .flat()
        .map((l) => l.lotId);
      const crmEntityTypes = [];

      if (this.isDeal) crmEntityTypes.push("DEAL");
      if (this.isLead) crmEntityTypes.push("LEAD");

      this.backHandler();

      const data = {
        lotIds,
        crmEntityTypes,
        titleOverrides: this.titleOverrides,
      };

      try {
        await this.sendToBitrixHandler(data);
      } catch (e) {
        this.$toast.error("Произошла ошибка");
      }
    },
    async sendToBitrixHandler(data) {
      const res = await this.sendToBitrix(data);
      if (res.data.completed && !res.data.jobErrorMessage) {
        this.$toast.success("Отправка в битрикс прошла успешно");
        return;
      } else if (res.data.completed && res.data.jobErrorMessage) {
        this.$toast.error(res.data.jobErrorMessage);
        return;
      }
      await this.sendToBitrixHandler(data);
    },
  },
  watch: {
    lastSelectedEntityTypes: {
      immediate: true,
      handler(value) {
        this.isLead = value.includes("LEAD");
        this.isDeal = value.includes("DEAL");
      },
    },
  },
  beforeDestroy() {
    this.resetBitrixExportState();
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variables.less";

.modal-content {
  display: flex;
  flex-direction: column;
  max-height: 637px;
  padding: 32px 16px 92px 0;
  position: relative;
  .content-container {
    overflow: auto;
    padding: 0 10px 0 32px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    &::-webkit-scrollbar {
      border-radius: @br;
      width: 8px;
      background-color: #ffffff;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: @br;
      width: 8px;
      background-color: fade(#000000, 24%);
      &:hover {
        background-color: fade(#000000, 30%);
      }
    }
  }
  .content-container > *:last-child {
    margin-bottom: 16px;
  }
  .content-container > .title-error {
    font-size: 24px;
    font-weight: 500;
    width: 100%;
    text-align: center;
    margin: 0;
    margin-bottom: 24px;
  }
  .modal-footer {
    padding: 0 32px;
    height: 92px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 2px solid #cfd8dd;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #ffffff;
    .btns-container {
      display: flex;
      gap: 16px;
      .toggle-btn {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        span {
          &:first-child {
            position: relative;
            display: block;
            margin-right: 16px;
            border-radius: 12px;
            min-width: 48px;
            height: 24px;
            background-color: @bg-color-middle;
            transition: @trans;

            &::before {
              content: "";
              position: absolute;
              left: 3px;
              top: 2px;
              border-radius: 50%;
              width: 20px;
              height: 20px;
              background-color: #ffffff;
              transition: @trans;
            }
          }
        }

        &.active {
          span:first-child {
            background-color: @bg-color-dark;

            &::before {
              left: 25px;
            }
          }
        }
      }
      .btn {
        width: 160px;
        height: 44px;
        font-family: Roboto;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
      }
      .btn.btn-cancel {
        background-color: #edeff1;
        color: #000;
      }
      .btn.btn-export {
        background-color: #7d919b;
      }
    }
  }
}
</style>
